<template>
  <article class="base-modal" @click="handleCancel">
    <section class="init__popup">
      <div class="init__title">
        <i18n-t keypath="general.init_description1" tag="span">
          <template #touch>
            <span class="emphasis">{{ t('general.touch') }}</span>
          </template>
        </i18n-t>
      </div>
      <div class="init__contents">
        <div class="init__image"><img src="@/assets/images/icon-touch.png" alt="초기화 이미지" /></div>
        <div class="init__count">
          <span
            >{{ t('label.remaining_time') }} : <span class="emphasis">{{ countdown }}&nbsp;</span
            >{{ t('label.seconds') }}</span
          >
        </div>
        <div v-if="cartStore.cart.CartMenus.length > 0" class="init__description">
          <span>{{ t('general.init_description2') }}</span>
        </div>
      </div>
      <div class="init__button">
        <BaseButton>
          {{ t('button.continue') }}
        </BaseButton>
      </div>
    </section>
  </article>
</template>

<script setup lang="ts">
  import BaseButton from '@/components/base/BaseButton.vue';
  import { useCartStore } from '@/stores/cart';
  import { useCommonStore } from '@/stores/common';
  import { useConfigStore } from '@/stores/config';
  import { onBeforeUnmount, onMounted, ref } from 'vue';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
  const commonStore = useCommonStore();
  const configStore = useConfigStore();
  const cartStore = useCartStore();

  // 대기 화면 전환 인터벌 아이디
  let intervalId: ReturnType<typeof setInterval>;

  // 대기 화면으로 전환하는 카운트다운
  const countdown = ref(configStore.config.WaitingPopupCountdown);

  onMounted(() => {
    // 카운트다운 1초 타이머 설정
    intervalId = setInterval(async () => {
      // 카운트가 완료되면 대기 화면으로 전환하는 로직 실행
      if (countdown.value === 0) {
        const loadingId = commonStore.showLoading();
        try {
          clearInterval(intervalId);
          await commonStore.setWaitingState();
        } finally {
          commonStore.hideLoading(loadingId);
        }
      }
      countdown.value -= 1;
    }, 1000);
  });

  onBeforeUnmount(() => {
    // 팝업이 닫히는 경우 인터벌 해제
    clearInterval(intervalId);
  });

  const handleCancel = () => {
    // 대기 팝업 닫기
    commonStore.closeWaitingPopup();

    // 대기 팝업 타임아웃 재설정
    commonStore.setWaitingPopupInterval();
  };
</script>

<style scoped lang="scss">
  @use '@/assets/scss/variables' as vars;

  .base-modal {
    z-index: vars.$z-index-waiting;
  }

  .init__popup {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    gap: 2.9851vw;
    padding: 2.2388vw;
    width: 59.7015vw;
    background-color: #fff;
    .init__title {
      text-align: center;
      span {
        font-size: 2.9851vw;
        font-weight: bold;
        word-break: keep-all;
      }
    }
    .init__contents {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      gap: 1.4925vw;
      .init__image {
        text-align: center;
        img {
          width: 22.3881vw;
        }
      }
      .init__count {
        text-align: center;
        border: 0.0746vw dashed #707070;
        border-radius: 34px;
        padding: 0.7463vw 1.8657vw;
        text-align: center;
        font-size: 2.0896vw;
        font-weight: bold;
      }
      .init__description {
        span {
          font-size: 2.0896vw;
        }
      }
    }
    .init__button {
      width: 31.3433vw;
    }
  }
  .emphasis {
    color: #d7201a;
  }

  @media (max-width: vars.$md) {
    .init__popup {
      .init__title {
        span {
          font-size: 22px;
        }
      }
      .init__contents {
        .init__image {
          img {
            width: 80%;
          }
        }
        .init__count {
          font-size: 14px;
        }
        .init__description {
          span {
            font-size: 14px;
          }
        }
      }
      .init__button {
        width: 100%;
      }
    }
  }
</style>
